import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDboE9bjpX9VsXXro2R2cDJO0hzlJmmPtg",
  authDomain: "signal-clone-c1cd1.firebaseapp.com",
  projectId: "signal-clone-c1cd1",
  storageBucket: "signal-clone-c1cd1.appspot.com",
  measurementId: "G-MVDH5RFXEN"
});

const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();


export { db, auth,storage };